module.exports = __webpack_public_path__ + "static/media/chandizhengshenqingliucheng7.b60fdfb6.png";